import qs from 'qs';

export default function parseQueryFromSearchParams(
  searchParams: URLSearchParams
) {
  const parsed = qs.parse(searchParams.toString(), {
    ignoreQueryPrefix: true,
    decoder,
  });
  return parsed;
}

/**
 *
 * @returns the full url parameter including the key, eg: filters[key][0]=value
 */
export const getRawUrlParameterFromUrl = (
  url: string,
  parameterKey: string
) => {
  const value =
    (url.split('?')[1] || '')
      .split('&')
      .find((item) => item.startsWith(parameterKey)) || '';
  return value;
};

export const decoder = (
  str: string,
  defaultDecoder: qs.defaultDecoder,
  charset: string,
  type: string
) => {
  if (type === 'key') {
    return decodeURIComponent(str);
  }

  try {
    // Handle array format
    if (str.startsWith('{') || str.includes(',')) {
      const parsed = JSON.parse(str.replace(/'/g, '"'));
      return parsed;
    }

    return defaultDecoder(str);
  } catch {
    return defaultDecoder(str);
  }
};
